import {employeeStatus} from "$lib/options";
import type {Employee} from "$lib/types/employee";
import dayjs from "dayjs";
import DataTrafficLight from "$lib/components/ui/DataTrafficLight.svelte";


export let ReadEmployees = (): Array<SortableTableHeaderElement> => ([
    {
        label: 'Beworben am',
        property: 'createdAt',
        sortable: true,
        movable: true,
        hidden: true,
        render: (data: Employee) => dayjs(data.createdAt.value).format('DD.MM.YYYY') ,
    },
    {
        label: 'Stammdaten',
        property: 'index',
        sortable: true,
        movable: true,
        hidden: false,

        component: DataTrafficLight ,
    },
    {
        label: 'PNR',
        property: 'employeeNumber',
        sortable: true,
        movable: true,
        hidden: true,
        render: (data: Employee) => data.employeeNumber || 'Nicht vergeben',

    },
    {
        label: 'Vorname',
        property: 'firstName',
        sortable: true,
        movable: true,
    },
    {
        label: 'Nachname',
        property: 'lastName',
        sortable: true,
        movable: true,
    },
    {
        label: 'E-Mail',
        property: 'email',
        sortable: true,
        movable: true,
        hidden: true,
    },
    {
        label: 'Telefon',
        property: 'mobile',
        sortable: true,
        movable: true,
        hidden: true,
    },
    {
        label: 'Status',
        property: 'employmentStatus',
        render: (data: Employee) => employeeStatus[data.employmentStatus as string] ?? 'Unbekannt',
    },
    {
        label: 'Bereich',
        property: 'area',
        sortable: true,
        movable: true,
    },
    {
        label: 'Vertragsbeginn',
        property: 'contract_history.startDate',
        render: activeOrUpcomingContract,
        sortable: true,
        movable: true,
        customSort: (a, b, c) => a?.currentContract?.currentHistory?.startDate?.stamp < b?.currentContract?.currentHistory?.startDate?.stamp ? c : -1*c
    }
])

const activeOrUpcomingContract = (data: Employee) => {
    let start = null;
    if(data.currentContract){
        start = dayjs(data.currentContract.currentHistory?.startDate?.value)
    }
    if((!start || start.isBefore(dayjs())) && data.contracts.length > 0){
        const lastContract = data.contracts[data.contracts.length - 1];
        start = dayjs(lastContract.currentHistory?.startDate?.value)
    }

    return start ? start.format('DD.MM.YYYY') : 'n/a'
}